<template>
  <div>
    <el-dropdown @command="OnActionClicked">
      <!--  style="cursor: pointer"
        @click="onClicked(column, row)" -->
      <el-tag
        v-if="rowValue != 0 && rowValue != null"
        :class="ClassObject"
        style="cursor: pointer"
        plain
      >
        {{ Amount }} <i class="el-icon-arrow-down el-icon--right"></i>
        <!--<span v-if="Months.includes(column.property)"></span>-->
      </el-tag>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="execute">Ejecutar</el-dropdown-item>
        <el-dropdown-item command="edit">Editar</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { formatterMoney } from "@/utils";

export default {
  name: "LinkDialogOpenerForPaymentAndInvoicingReport",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    },
    onActionClicked: {
      type: Function,
      default: () => {},
      required: false
    }
  },
  data() {
    return {
      Months: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      }
    };
  },
  computed: {
    ClassObject() {
      const actualMonth = new Date().getMonth() + 1;
      const isBlue = false;
      let isRed = false;
      let isGreen = false;
      let isYellow = false;

      const now = new Date();
      const endDate = new Date(this.row[`${this.column.property}_EndDate`]);

      if (this.Months[this.column.property] === actualMonth && now <= endDate) {
        isYellow = true;
        isRed = false;
        isGreen = false;
      }

      if (this.row[this.column.property + "_Paid"] === 1) {
        isGreen = true;
        isYellow = false;
        isRed = false;
      }
      if (this.row[this.column.property + "_Paid"] === 0 && now > endDate) {
        isRed = true;
        isGreen = false;
        isYellow = false;
      }

      let classObject;
      classObject = {
        Blue: isBlue,
        Red: isRed,
        Green: isGreen,
        Yellow: isYellow,
        Bold: true
      };

      return classObject;
    },
    Amount() {
      let amount = formatterMoney(this.rowValue);
      return amount;
    }
  },
  methods: {
    formatterMoney,
    onClicked(column, row) {
      this.call(column, row);
    },
    OnActionClicked(command) {
      this.onActionClicked({
        command: command,
        column: this.column,
        row: this.row
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
